import { Link } from 'react-router';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { PageContent } from 'components/page';
import { SVGButton } from 'components/widgets/buttons';
import { Table } from 'components/content-containers/tables';
import { getFileOpenUrl, getFormUrl } from 'utils/google-drive-utils';
import Person from 'services/data/person';
import SVG from 'components/widgets/icons/svg';

import * as actions from '../store/actions';


export default function CompanyForms({ id, currentUser }) {
  const { data: company } = actions.useCompany(id);
  const { data: forms } = actions.useCompanyForms(id);

  if (!forms) return null;

  const isLead = Person.isLead(currentUser);
  const month = moment().subtract(30, 'days');
  const year = moment().subtract(1, 'year');

  return (
    <PageContent>
      <div>
        { isLead &&
          <Link to={`/companies/${company.id}/forms/add`} className="full-page-add-link offset-page-padding btn-success">
            <div>
              <SVG src="svg/add.svg" className="add mr-2" />
              <span>New Form</span>
            </div>
            <SVG src="svg/checklist.svg" />
          </Link>
        }
        <Table>
          <thead>
            <tr>
              <th>Form</th>
              <th className="collapse-width text-right">Last 30 days</th>
              <th className="collapse-width text-right">Last year</th>
              <th className="collapse-width text-right"></th>
            </tr>
          </thead>
          <tbody>
            {_.map(forms, (form) => {
              const monthlyResponses = _.filter(form.responses, response => moment(response.timestamp).isAfter(month));
              const yearlyResponses = _.filter(form.responses, response => moment(response.timestamp).isAfter(year));

              return (
                <tr key={form.id}>
                  <td><Link to={`/companies/${company.id}/forms/${form.id}/responses`}>{form.title}</Link></td>
                  <td className="collapse-width text-right">{monthlyResponses.length}</td>
                  <td className="collapse-width text-right">{yearlyResponses.length}</td>
                  <td className="text-right no-padding options-cell">
                    <a target="_blank" href={getFormUrl(form.form.fileId)}>
                      <SVGButton src="svg/link.svg" title="Form Link" />
                    </a>
                    <a target="_blank" href={getFileOpenUrl(form.form.fileId)}>
                      <SVGButton src="svg/cog.svg" title="Edit Form" />
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </PageContent>
  );
}
